// export const base_url = "http://localhost:5000/";
// export const base_url = "http://217.154.38.128:5000/";
export const base_url ="https://portal.ayrshiredrinks.com/";
